<template>
  <section
    class="layout-pt-lg layout-pb-lg"
    :style="`background-color: var(--c-${vars.backgroundColor}); 
    `"
  >
    <div class="container tw-grid tw-w-full tw-grid-cols-12 tw-gap-y-12 lg:tw-gap-x-12">
      <div class="tw-col-span-12">
        <div class="tw-mb-10 tw-w-full">
          <div class="tw-mb-10" v-html="vars.titleHtml"></div>
          <div class="tw-flex tw-flex-col tw-gap-4 lg:tw-flex-row">
            <search-box
              v-model="keyword"
              :search-result-list="[]"
              :placeholder="searchBoxPlaceholder"
              :search-method="onSearched"
              version="v2"
            />
            <div class="tw-mt-10 tw-flex tw-flex-col tw-gap-4 md:tw-flex-row md:tw-items-center lg:tw-mt-0">
              <small class="tw-uppercase lg:tw-whitespace-nowrap" style="color: var(--c-text_tertiary)"
                >available on all your favourite platforms:</small
              >
              <div class="tw-mt-2 tw-flex tw-items-center tw-gap-x-6 md:tw-mt-0 md:tw-pb-1">
                <nuxt-link class="n-link" :to="vars.spotifyLinkUrl" target="_blank" :external="true"
                  ><span>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M2 12C2 6.48 6.48 2 12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12Z"
                        stroke="black"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M8.62891 15.31C10.8089 14.73 13.1189 14.97 15.1289 16"
                        stroke="black"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M7.5 12.07C8.6 11.7 9.78 11.5 11 11.5C13.02 11.5 14.92 12.05 16.55 13"
                        stroke="black"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M7 8.91C8.38 8.32 9.9 8 11.5 8C13.91 8 16.15 8.74 18 10"
                        stroke="black"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg> </span
                ></nuxt-link>
                <nuxt-link class="n-link" :to="vars.appleLinkUrl" target="_blank" :external="true"
                  ><span
                    ><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M12.05 2.07202H11.95C9.88 2.07202 8.26 2.07202 6.98 2.23202C5.67 2.38202 4.63 2.71202 3.77 3.45202C3.54 3.64202 3.33 3.86202 3.13 4.09202C2.4 4.94202 2.07 5.99202 1.91 7.30202C1.75 8.57202 1.75 10.202 1.75 12.272V12.372C1.75 14.442 1.75 16.072 1.91 17.342C2.07 18.652 2.4 19.702 3.13 20.552C3.33 20.782 3.54 21.002 3.77 21.192C4.63 21.932 5.67 22.262 6.98 22.412C8.26 22.572 9.88 22.572 11.95 22.572H12.05C14.12 22.572 15.74 22.572 17.02 22.412C18.33 22.262 19.37 21.932 20.23 21.192C20.46 21.002 20.67 20.782 20.87 20.552C21.6 19.702 21.93 18.652 22.09 17.342C22.25 16.072 22.25 14.442 22.25 12.372V12.272C22.25 10.202 22.25 8.57202 22.09 7.30202C21.93 5.99202 21.6 4.94202 20.87 4.09202C20.67 3.86202 20.46 3.64202 20.23 3.45202C19.37 2.71202 18.33 2.38202 17.02 2.23202C15.74 2.07202 14.12 2.07202 12.05 2.07202ZM4.74 4.59202C5.28 4.12202 6 3.86202 7.16 3.71202C8.34 3.57202 9.87 3.57202 12 3.57202C14.13 3.57202 15.67 3.57202 16.84 3.71202C18 3.86202 18.71 4.12202 19.26 4.59202C19.43 4.73202 19.59 4.89202 19.73 5.06202C20.19 5.60202 20.46 6.32202 20.6 7.48202C20.74 8.65202 20.74 10.192 20.74 12.322C20.74 14.452 20.74 15.992 20.6 17.162C20.46 18.322 20.19 19.042 19.73 19.582C19.58 19.752 19.43 19.912 19.26 20.052C18.72 20.522 18 20.782 16.84 20.932C15.66 21.072 14.13 21.072 12 21.072C9.87 21.072 8.33 21.072 7.16 20.932C6 20.782 5.29 20.522 4.74 20.052C4.57 19.912 4.41 19.752 4.27 19.582C3.81 19.042 3.54 18.322 3.4 17.162C3.26 15.992 3.26 14.452 3.26 12.322C3.26 10.192 3.26 8.65202 3.4 7.48202C3.54 6.32202 3.81 5.60202 4.27 5.06202C4.42 4.89202 4.57 4.73202 4.74 4.59202ZM16.75 6.82202C16.75 6.59202 16.65 6.38202 16.47 6.24202C16.3 6.10202 16.07 6.04202 15.85 6.08202L9.35 7.40202C9.17975 7.43677 9.02685 7.52955 8.91742 7.66452C8.80798 7.79949 8.74881 7.96827 8.75 8.14202V15.682L7.18 16.282C6.82328 16.4213 6.53649 16.6965 6.38271 17.0472C6.22893 17.3979 6.22076 17.7953 6.36 18.152C6.49924 18.5087 6.77448 18.7955 7.12517 18.9493C7.47587 19.1031 7.87328 19.1113 8.23 18.972L9.15 18.602C9.81 18.332 10.25 17.692 10.25 16.972V10.432L15.25 9.44202V14.182L13.68 14.782C13.12 14.992 12.75 15.532 12.75 16.132C12.75 17.152 13.78 17.842 14.73 17.472L15.65 17.102C16.31 16.832 16.75 16.192 16.75 15.472V6.82202Z"
                        fill="black"
                      /></svg></span
                ></nuxt-link>
                <nuxt-link class="n-link" :to="vars.soundcloudLinkUrl" target="_blank" :external="true"
                  ><span
                    ><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_217_660)">
                        <path
                          d="M2.25 11.25V15.75C2.25 15.9489 2.17098 16.1397 2.03033 16.2803C1.88968 16.421 1.69891 16.5 1.5 16.5C1.30109 16.5 1.11032 16.421 0.96967 16.2803C0.829018 16.1397 0.75 15.9489 0.75 15.75V11.25C0.75 11.0511 0.829018 10.8603 0.96967 10.7197C1.11032 10.579 1.30109 10.5 1.5 10.5C1.69891 10.5 1.88968 10.579 2.03033 10.7197C2.17098 10.8603 2.25 11.0511 2.25 11.25ZM4.5 8.25C4.30109 8.25 4.11032 8.32902 3.96967 8.46967C3.82902 8.61032 3.75 8.80109 3.75 9V18C3.75 18.1989 3.82902 18.3897 3.96967 18.5303C4.11032 18.671 4.30109 18.75 4.5 18.75C4.69891 18.75 4.88968 18.671 5.03033 18.5303C5.17098 18.3897 5.25 18.1989 5.25 18V9C5.25 8.80109 5.17098 8.61032 5.03033 8.46967C4.88968 8.32902 4.69891 8.25 4.5 8.25ZM7.5 7.5C7.30109 7.5 7.11032 7.57902 6.96967 7.71967C6.82902 7.86032 6.75 8.05109 6.75 8.25V18C6.75 18.1989 6.82902 18.3897 6.96967 18.5303C7.11032 18.671 7.30109 18.75 7.5 18.75C7.69891 18.75 7.88968 18.671 8.03033 18.5303C8.17098 18.3897 8.25 18.1989 8.25 18V8.25C8.25 8.05109 8.17098 7.86032 8.03033 7.71967C7.88968 7.57902 7.69891 7.5 7.5 7.5ZM10.5 4.5C10.3011 4.5 10.1103 4.57902 9.96967 4.71967C9.82902 4.86032 9.75 5.05109 9.75 5.25V18C9.75 18.1989 9.82902 18.3897 9.96967 18.5303C10.1103 18.671 10.3011 18.75 10.5 18.75C10.6989 18.75 10.8897 18.671 11.0303 18.5303C11.171 18.3897 11.25 18.1989 11.25 18V5.25C11.25 5.05109 11.171 4.86032 11.0303 4.71967C10.8897 4.57902 10.6989 4.5 10.5 4.5ZM20.8913 9.96937C20.5895 8.22803 19.6825 6.64918 18.3302 5.51132C16.9779 4.37345 15.2673 3.74967 13.5 3.75C13.3011 3.75 13.1103 3.82902 12.9697 3.96967C12.829 4.11032 12.75 4.30109 12.75 4.5C12.75 4.69891 12.829 4.88968 12.9697 5.03033C13.1103 5.17098 13.3011 5.25 13.5 5.25C14.9879 5.24475 16.4242 5.79457 17.5282 6.79198C18.6323 7.78939 19.3246 9.1627 19.47 10.6434C19.4872 10.803 19.5551 10.9529 19.6638 11.071C19.7724 11.1892 19.9161 11.2693 20.0737 11.2997C20.8125 11.4356 21.4733 11.8437 21.9257 12.4433C22.3781 13.0429 22.5891 13.7904 22.517 14.5381C22.4449 15.2858 22.095 15.9792 21.5364 16.4813C20.9777 16.9834 20.2511 17.2577 19.5 17.25H13.5C13.3011 17.25 13.1103 17.329 12.9697 17.4697C12.829 17.6103 12.75 17.8011 12.75 18C12.75 18.1989 12.829 18.3897 12.9697 18.5303C13.1103 18.671 13.3011 18.75 13.5 18.75H19.5C20.572 18.7508 21.6091 18.3689 22.4245 17.673C23.2399 16.9771 23.7802 16.013 23.9479 14.9542C24.1157 13.8954 23.8999 12.8115 23.3396 11.8977C22.7792 10.9838 21.911 10.3 20.8913 9.96937Z"
                          fill="black"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_217_660">
                          <rect width="24" height="24" fill="white" />
                        </clipPath>
                      </defs>
                    </svg> </span
                ></nuxt-link>
              </div>
            </div>
          </div>
        </div>

        <div class="tw-grid tw-grid-cols-12 tw-gap-x-6 tw-gap-y-10 xl:tw-gap-x-10">
          <div
            v-for="(podcast, index) in filteredPodcasts"
            class="tw-group tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4"
            :key="index"
          >
            <div class="tw-relative">
              <library-iframe :src="podcast.video" :w-ratio="16" :h-ratio="9" />
            </div>
            <h5 class="tw-mt-8 tw-line-clamp-2 tw-h-[50px] tw-uppercase !tw-text-black">
              {{ podcast.title }}
            </h5>
            <p class="tw-mt-2" style="color: var(--c-text_tertiary) !important">{{ podcast.description }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { mapState } from 'pinia';
import type { Component } from '~/types';
import Loader from '~/components/common/Loader.vue';
import NotFound from '~/components/theme4/base/NotFound.vue';
import indexGlobal from '~/mixins/index.global';
import NcButton from '~/components/common/inputs/NcButton.vue';
import { ComponentMixin } from '~/mixins/component.mixin';
import SearchBox from '~/components/common/SearchBox.vue';
import { useWebsiteStore } from '~/units/website/store';
import { ROUTES } from '~/constants/ui.constants';

export default defineNuxtComponent({
  name: 'Theme7Podcasts',
  components: { SearchBox, NcButton, NotFound, Loader },

  mixins: [indexGlobal, ComponentMixin],

  computed: {
    ...mapState(useWebsiteStore, ['theme']),

    variant() {
      return useVariant(this.component);
    },

    podcasts() {
      return this.groupedVariables.podcasts;
    },

    filteredPodcasts() {
      if (!this.keyword) return this.podcasts;
      const lowerKeyword = this.keyword.toLowerCase();
      return this.podcasts.filter(
        (podcast) =>
          podcast.title.toLowerCase().includes(lowerKeyword) ||
          podcast.description.toLowerCase().includes(lowerKeyword),
      );
    },

    backgroundColor() {
      return getVariable(this.component, 'background-color');
    },

    titleHtml() {
      return this.vars.titleHtml;
    },

    ROUTES() {
      return ROUTES;
    },

    is() {
      return defineAsyncComponent(
        /* TODO: ~ didn't work when I used it. */
        () => import(`../AvailableComponentsForSidebar.vue`),
      );
    },
  },
  data() {
    return {
      variants: {
        v1: 'v1',
      },
      keyword: '',
      searchBoxPlaceholder: 'Search',
    };
  },

  mounted() {
    const route = useRoute();
    if (route.query.q) {
      this.keyword = route.query.q as string;
    }
  },

  methods: {
    async onSearched() {
      // Triggered when the search box is used
      // The filtering is already handled by the computed property `filteredPodcasts`
    },
  },
});
</script>
